import React, { FunctionComponent } from "react";

import { useLanguage } from "../../../i18n/useLanguage";
import {
  AnyOrderItem,
  VehicleInformation,
} from "../../../stores/slices/cartSlice";
import { CartPrintOrderItem } from "./CartPrintOrderItem";

type CartPrintPageProps = {
  orders: AnyOrderItem[];
  vehicle: VehicleInformation | null;
};

export const CartPrintPage: FunctionComponent<CartPrintPageProps> = ({
  orders,
  vehicle,
}) => {
  const [language] = useLanguage();
  return (
    <section className="space-y-2">
      <h2 className="text-xl font-semibold mt-6">
        {vehicle?.vehicleTitle[language] || " "}
      </h2>
      {orders?.map((orderItem) => (
        <CartPrintOrderItem key={orderItem.itemId} orderItem={orderItem} />
      ))}
    </section>
  );
};
